import React from "react";
import { useTheme } from "react-jss";
import { useSelector } from "react-redux";
import classnames from "classnames";
import { FontAwesomeIcon } from "../../shared/FontAwesome";
import { PageValidationErrorIcon } from "../../shared/ValidationErrorIcons";
import useStyles from "./ValidationSummaryRenderer.styles";
import { RecalledText } from "../../../containers/shared/RecalledText";
import { translate } from "../../../models/utilities/translationUtilities";
import type { StoreState } from "../../../models/states/StoreState";
import type { Theme } from "../../../types/Theme";

export default function ValidationSummary({ language, questionnaire, isValid }) {
    const theme = useTheme() as Theme;
    const classes = useStyles({ theme });
    const useModernTheme = Boolean(theme.UseModernTheme);
    // Changes on each failed Next/Submit; keying the alert on it forces a remount so an
    // unchanged "Page has errors" re-announces in NVDA on a repeated submit (DEV-97358).
    const announceSeq = useSelector((state: StoreState) => state.interview.validationAnnounceSeq);

    if (isValid) {
        return null;
    }

    return (
        <div key={announceSeq} className={classes.errorContainer} role="alert">
            {useModernTheme ? (
                <PageValidationErrorIcon
                    className={classnames(classes.icon, classes.iconSvg)}
                />
            ) : (
                <FontAwesomeIcon
                    icon="exclamation-circle"
                    className={classnames(classes.icon, classes.iconFontAwesome)}
                />
            )}
            <RecalledText
                text={translate(questionnaire, "PageHasErrors", language)}
                render={(recalled) => (
                    <span
                        className={classes.errorMessage}
                        dangerouslySetInnerHTML={{ __html: recalled }}
                    />
                )}
            />
        </div>
    );
}
